<template>
  <div :class="{ 'z-player': true, 'z-player--no-title': is_hidden_name }">
    <!--<div v-if="!is_file_converted" class="loader">
      <div class="spinner-wrap">
        <b-spinner variant="primary" label="Spinning" />
      </div>
    </div>-->

    <a-player :music="music" class="zorra-aplayer" />

    <div class="z-player__icons">
      <slot name="controls"></slot>
    </div>
  </div>
</template>

<script>
  import APlayer from 'vue-aplayer';
  APlayer.disableVersionBadge = true;

  export default {
    components: {
      APlayer
    },

    props: {
      music: {
        type: Object,
        required: true
      },

      is_hidden_name: {
        type: Boolean,
        default: false
      },

      is_file_converted: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style lang="scss">
  .z-player {
    display: flex;
    width: 100%;
    flex-direction: row;
    position: relative;

    .aplayer {
      width: 100%;
    }

    .aplayer-author {
      display: none;
    }

    &--no-title .aplayer-music {
      visibility: hidden;
    }

    &__icons {
      display: flex;
      align-items: flex-end;

      &:empty {
        display: none;
      }
    }
  }
</style>
